import { render, staticRenderFns } from "./tiscPagination.vue?vue&type=template&id=7cc44fd0&scoped=true&"
import script from "./tiscPagination.vue?vue&type=script&lang=js&"
export * from "./tiscPagination.vue?vue&type=script&lang=js&"
import style0 from "./tiscPagination.vue?vue&type=style&index=0&id=7cc44fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc44fd0",
  null
  
)

export default component.exports